export default __webpack_public_path__ + "static/media/Beard_8_C5.0ec6046e.svg";